import { SocialLink } from './model';

export const SOCIAL_LINKS: ReadonlyArray<SocialLink> = [
  {
    name: 'MAX',
    url: 'https://max.ru/id7714905086_biz',
    icon: '/icons/max.svg',
    wide: false,
  },
  {
    name: 'Telegram',
    url: 'https://t.me/chefsbreakfast',
    icon: '/icons/telegram.svg',
    wide: false,
  },
  {
    name: 'Дзен',
    url: 'https://zen.yandex.ru/chefsbreakfast',
    icon: '/icons/dzen.svg',
    wide: false,
  },
  {
    name: 'ВКонтакте',
    url: 'https://vk.com/chefsbreakfast',
    icon: '/icons/vkontakte.svg',
    wide: true,
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UCeigkyTy_SvCnVLh1LKnLrQ',
    icon: '/icons/youtube.svg',
    wide: true,
  },
] as const;
